import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseMerchantShipSettingsScheduleV2ProblemType as SchemaDeliveryWarehouseMerchantShipSettingsScheduleV2ProblemType } from '../schemas/DeliveryWarehouseMerchantShipSettingsScheduleV2ProblemType';
import { type DeliveryWarehouseMerchantShipSettingsV2Request as SchemaDeliveryWarehouseMerchantShipSettingsV2Request } from '../schemas/DeliveryWarehouseMerchantShipSettingsV2Request';
import { type DeliveryWarehouseMerchantShipSettingsV2Response as SchemaDeliveryWarehouseMerchantShipSettingsV2Response } from '../schemas/DeliveryWarehouseMerchantShipSettingsV2Response';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateDeliveryWarehouseMerchantShipSettingsV2ContentType = 'application/json' as const;
export type UpdateDeliveryWarehouseMerchantShipSettingsV2Request = SchemaDeliveryWarehouseMerchantShipSettingsV2Request;
export type UpdateDeliveryWarehouseMerchantShipSettingsV2Responses = LinkCommonErrorResponses & {
    /**
     * @description Updated warehouse delivery settings
     */
    '200': {
        'application/json': SchemaDeliveryWarehouseMerchantShipSettingsV2Response;
    };
    /**
     * @description Invalid merchant-operated delivery schedule
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaDeliveryWarehouseMerchantShipSettingsScheduleV2ProblemType;
        };
    };
};
export type UpdateDeliveryWarehouseMerchantShipSettingsV2ResponseSuccess =
    UpdateDeliveryWarehouseMerchantShipSettingsV2Responses['200']['application/json'];
export type UpdateDeliveryWarehouseMerchantShipSettingsV2SearchParams = undefined;
export type UpdateDeliveryWarehouseMerchantShipSettingsV2PathParameters = {
    warehouse_id: string;
};
export const UpdateDeliveryWarehouseMerchantShipSettingsV2Url =
    '/delivery/warehouse/{warehouse_id}/settings/merchant-ship' as const;
export const UpdateDeliveryWarehouseMerchantShipSettingsV2Method = 'PATCH' as const;
export const getUpdateDeliveryWarehouseMerchantShipSettingsV2Url = (
    params: UpdateDeliveryWarehouseMerchantShipSettingsV2PathParameters
) =>
    UpdateDeliveryWarehouseMerchantShipSettingsV2Url.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateDeliveryWarehouseMerchantShipSettingsV2PathParameters) => String(params[param])
    );
